<div class="photo-name-root"  *transloco="let t">
  <div class="left-panel">
    <app-rounded-image [src]="businessSummary?.picture" xsmall></app-rounded-image>
    <app-status class="status"
      [status]="businessSummary?.status">
    </app-status>
  </div>
  <div class="business-data">
    <span class="business-name">
      <span *ngIf="maxNameLength()" class="hovertext">{{ businessSummary?.name }}</span>
      {{ businessSummary?.name }}
    </span>
    <span class="registration-date">
      {{ t('registration-date') }}
      {{ businessSummary?.registerDate | date : 'MM.dd.yyyy' }}
    </span>
  </div>
</div>
